import { Reveal } from "./motion-primitives";
import { SectionLabel } from "./About";
import { useLang, Rich } from "@/i18n/LanguageContext";

export const Partnership = () => {
  const { c } = useLang();
  const p = c.partnership;
  return (
    <section data-testid="section-partnership" className="bg-paper px-6 py-24 text-ink md:px-[8vw] md:py-32">
      <Reveal>
        <SectionLabel n="06">{p.label}</SectionLabel>
      </Reveal>
      <div className="grid gap-12 md:grid-cols-[1.05fr_0.95fr] md:gap-[11vw]">
        <Reveal>
          <h2 className="font-serif text-[clamp(44px,5.2vw,80px)] font-normal leading-[1.0] tracking-[-0.02em]">
            <Rich text={p.title} />
          </h2>
        </Reveal>
        <Reveal delay={0.12} className="max-w-[590px] pt-2">
          <p className="mb-7 font-sans text-[22px] leading-[1.55]">{p.lead}</p>
          <p className="font-sans text-[15px] leading-[1.8] text-[#596360]">{p.p2}</p>
          <div className="mt-10 flex flex-wrap gap-2.5">
            {p.partners.map((x) => (
              <span key={x} className="border border-ink/15 px-3.5 py-2.5 font-sans text-[10px] uppercase tracking-[0.1em] text-[#5f6b68]">
                {x}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
